/* Retired in Phase 1C.
 *
 * The Residence Rail (RoomNav) is now the sole navigation surface across
 * every authenticated page. This component intentionally renders nothing
 * so its many callsites across every module can be migrated at leisure
 * without a mass search-and-replace.
 */
export function HomeOSSubNav() {
  return null;
}
